import styled from "styled-components";
import { darken } from "polished";
import { color } from "styles/variables";

export const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  backdrop-filter: blur(5px);
  --webkit-backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${darken(0.8, color.primary)};
  }
`;

export const Card = styled.div`
  padding: 30px;
  border-radius: 8px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  height: 100%;
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  margin-bottom: 20px;
`;

export const ErrorContent = styled.div`
  text-align: center;
  color: ${color.text};
  h3 {
    color: ${color.errorColor};
    margin-bottom: 15px;
    font-size: 24px;
    text-align: center;
  }
  p {
    font-size: 18px;
    text-align: center;
    margin-bottom: 30px;
    color: ${color.text};
  }
  .actions {
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const SuccessContent = styled.div`
  text-align: center;
  color: ${color.text};
  h3 {
    color: color: ${color.successColor};
    margin-bottom: 15px;
    font-size: 24px;
    text-align: center;
  }
  p {
    font-size: 18px;
    margin-bottom: 30px;
    text-align: center;
    color: ${color.text};
  }
  .actions {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
`;
